/**
 * 标签选择公共组件接口
 * @author liuys
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async getTagList() {
    return request(api.label.TAGGROUP + '/popSelectTagWithGroup', METHOD.GET);
  },
  async getWxTagList() {
    return request(api.label.TAGGROUP + '/popSelectWxTagWithGroup', METHOD.GET);
  },
  async getScrmTagList() {
    return request(api.label.TAGGROUP + '/popSelectScrmTagWithGroup', METHOD.GET);
  },
}


export default {dataApi}